import { render } from "./CircularProgress.vue?vue&type=template&id=5ed4a758&ts=true"
import script from "./CircularProgress.vue?vue&type=script&lang=ts"
export * from "./CircularProgress.vue?vue&type=script&lang=ts"

import "./CircularProgress.vue?vue&type=style&index=0&id=5ed4a758&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__